import platformBackendClient from '@backend-clients/platform-backend';

export default ({ customerId, product }) => platformBackendClient.post(`/api/subscriptions/${customerId}/access/${product}`)
  .then((res) => res.data);
